import { IExportColumnModel } from "../../../../../shared/models";

export const ConnectionsSemaphoresColumnList: IExportColumnModel[] = [
]